import * as actionTypes from './action-types'
import { Artists } from 'api'


export const fetchAll = () => {
    return async (dispatch, getState) => {
        try {
            
            const response = await Artists.fetchAll()
            const artists = response.data

            dispatch(fetchAllFulfilled(artists))
        }
        catch (e) {
            console.error(e)
        }
    } 
}

const fetchAllFulfilled = (payload) => {
    return {
        type: actionTypes.FETCH_ALL_FULFILLED,
        payload,
    }
}